// extracted by mini-css-extract-plugin
export default {"tableContent":"tablev2_tableContent__qbXE5","duration":"tablev2_duration__q9UkO","value":"tablev2_value__ieWvY"};